export type ComparisonSide = "before" | "after";

export const valueIntent = (side: ComparisonSide | undefined) => (side === "before" ? "muted" : undefined);

export const changedValueClassName = (side: ComparisonSide | undefined, changed: boolean) => {
	if (!changed) {
		return undefined;
	}
	if (side === "before") {
		return "line-through";
	}
	if (side === "after") {
		return "text-success";
	}
	return undefined;
};
